// Generated by Melange

import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__KkmJournal from "../../components/organisms/Kassa/KKM/KkmJournal.js";
import * as Buhta_cabinet__KkmJournalHeader from "../../components/organisms/Kassa/KKM/KkmJournalHeader.js";
import * as Buhta_cabinet__KkmMoneyPlacements from "../../components/organisms/Kassa/KKM/KkmMoneyPlacements.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__ShiftsTab from "./ShiftsTab.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function KkmJournalPage(Props) {
  let org = Props.org;
  let id = Props.id;
  let tab = Props.tab;
  let openMenu = Props.openMenu;
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const match$1 = React.useState(function () {
    
  });
  const setObjectId = match$1[1];
  const objectId = match$1[0];
  const match$2 = React.useState(function () {
    return "";
  });
  const objectType = match$2[0];
  let isShiftOpen;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string") {
    isShiftOpen = false;
  } else {
    switch (currentRoute.TAG) {
      case /* Org */ 6 :
        const match$3 = currentRoute._1;
        if (/* tag */ typeof match$3 === "number" || typeof match$3 === "string" || match$3.TAG !== /* Kassa */ 2) {
          isShiftOpen = false;
        } else {
          const match$4 = match$3._0._0;
          if (/* tag */ typeof match$4 === "number" || typeof match$4 === "string") {
            isShiftOpen = false;
          } else {
            const match$5 = match$4._1;
            if (/* tag */ typeof match$5 === "number" || typeof match$5 === "string" || match$5.TAG !== /* Journal */ 2) {
              isShiftOpen = false;
            } else {
              const match$6 = match$5._0;
              if (/* tag */ typeof match$6 === "number" || typeof match$6 === "string") {
                isShiftOpen = false;
              } else {
                let tmp = match$6._0;
                isShiftOpen = /* tag */ typeof tmp === "number" || typeof tmp === "string" || tmp.TAG !== /* View */ 0 ? false : true;
              }
            }
          }
        }
        break;
      case /* Admin */ 7 :
        const match$7 = currentRoute._0;
        if (/* tag */ typeof match$7 === "number" || typeof match$7 === "string" || match$7.TAG !== /* Orgs */ 1) {
          isShiftOpen = false;
        } else {
          const match$8 = match$7._0;
          if (/* tag */ typeof match$8 === "number" || typeof match$8 === "string") {
            isShiftOpen = false;
          } else {
            const match$9 = match$8._1;
            if (/* tag */ typeof match$9 === "number" || typeof match$9 === "string" || match$9.TAG !== /* Kassa */ 2) {
              isShiftOpen = false;
            } else {
              const match$10 = match$9._0._0;
              if (/* tag */ typeof match$10 === "number" || typeof match$10 === "string") {
                isShiftOpen = false;
              } else {
                const match$11 = match$10._1;
                if (/* tag */ typeof match$11 === "number" || typeof match$11 === "string" || match$11.TAG !== /* Journal */ 2) {
                  isShiftOpen = false;
                } else {
                  const match$12 = match$11._0;
                  if (/* tag */ typeof match$12 === "number" || typeof match$12 === "string") {
                    isShiftOpen = false;
                  } else {
                    let tmp$1 = match$12._0;
                    isShiftOpen = /* tag */ typeof tmp$1 === "number" || typeof tmp$1 === "string" || tmp$1.TAG !== /* View */ 0 ? false : true;
                  }
                }
              }
            }
          }
        }
        break;
      default:
        isShiftOpen = false;
    }
  }
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const header = JsxRuntime.jsx(Buhta_cabinet__KkmJournalHeader.make, {
    org: org,
    id: id,
    openMenu: openMenu,
    objectId: objectId,
    setObjectId: setObjectId,
    objectType: objectType
  });
  let tmp$2;
  if (deviceType === "mobile" && (objectId !== undefined || isShiftOpen)) {
    tmp$2 = null;
  } else {
    let tmp$3;
    tmp$3 = /* tag */ typeof tab === "number" || typeof tab === "string" ? false : true;
    let tmp$4;
    tmp$4 = /* tag */ typeof tab === "number" || typeof tab === "string" ? "text-gray-medium" : "text-links";
    tmp$2 = JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(Buhta_cabinet__Link.make, {
          route: contextRoute({
            TAG: /* Kassa */ 2,
            _0: {
              TAG: /* Kkms */ 0,
              _0: {
                TAG: /* Kkm */ 0,
                _0: id,
                _1: {
                  TAG: /* Journal */ 2,
                  _0: /* Logs */ 0
                }
              }
            }
          }),
          className: Cn.fromList({
            hd: "py-2.5 grow lg:grow-0",
            tl: {
              hd: Cn.on("border-b border-links", tab === /* Logs */ 0),
              tl: /* [] */ 0
            }
          }),
          children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            className: Cn.fromList({
              hd: "text-center",
              tl: {
                hd: tab === /* Logs */ 0 ? "text-links" : "text-gray-medium",
                tl: /* [] */ 0
              }
            }),
            children: "Журнал"
          })
        }),
        JsxRuntime.jsx(Buhta_cabinet__Link.make, {
          route: contextRoute({
            TAG: /* Kassa */ 2,
            _0: {
              TAG: /* Kkms */ 0,
              _0: {
                TAG: /* Kkm */ 0,
                _0: id,
                _1: {
                  TAG: /* Journal */ 2,
                  _0: {
                    TAG: /* Shifts */ 0,
                    _0: /* List */ 0
                  }
                }
              }
            }
          }),
          className: Cn.fromList({
            hd: "py-2.5 grow lg:grow-0",
            tl: {
              hd: Cn.on("border-b border-links", tmp$3),
              tl: /* [] */ 0
            }
          }),
          children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            className: Cn.fromList({
              hd: "text-center",
              tl: {
                hd: tmp$4,
                tl: /* [] */ 0
              }
            }),
            children: "Смены"
          })
        }),
        JsxRuntime.jsx(Buhta_cabinet__Link.make, {
          route: contextRoute({
            TAG: /* Kassa */ 2,
            _0: {
              TAG: /* Kkms */ 0,
              _0: {
                TAG: /* Kkm */ 0,
                _0: id,
                _1: {
                  TAG: /* Journal */ 2,
                  _0: /* MoneyPlacements */ 1
                }
              }
            }
          }),
          className: Cn.fromList({
            hd: "py-2.5 grow lg:grow-0",
            tl: {
              hd: Cn.on("border-b border-links", tab === /* MoneyPlacements */ 1),
              tl: /* [] */ 0
            }
          }),
          children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            className: Cn.fromList({
              hd: "text-center",
              tl: {
                hd: tab === /* MoneyPlacements */ 1 ? "text-links" : "text-gray-medium",
                tl: /* [] */ 0
              }
            }),
            children: "Наличные в кассе"
          })
        })
      ],
      className: "bg-white px-2 lg:px-6 border-b border-gray-main w-full flex lg:gap-4 justify-between lg:justify-start"
    });
  }
  let tmp$5;
  tmp$5 = /* tag */ typeof tab === "number" || typeof tab === "string" ? (
      tab === /* Logs */ 0 ? JsxRuntime.jsx(Buhta_cabinet__KkmJournal.make, {
          id: id,
          orgId: org.id,
          objectId: objectId,
          setObjectId: setObjectId,
          objectType: objectType,
          setObjectType: match$2[1]
        }) : JsxRuntime.jsx(Buhta_cabinet__KkmMoneyPlacements.make, {
          id: id
        })
    ) : JsxRuntime.jsx(Buhta_cabinet__ShiftsTab.make, {
      id: id,
      orgId: org.id
    });
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
    header: header,
    children: JsxRuntime.jsxs("div", {
      children: [
        tmp$2,
        tmp$5
      ],
      className: "w-full flex flex-col items-center overflow-y-auto"
    })
  });
}

const make = KkmJournalPage;

export {
  make,
}
/* Buhta_cabinet__DashboardContentTemplate Not a pure module */
